<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'ItineraryPricesSelectedCarRentals',
  components: {
  },
  props: {
    selectedPriceInterval: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        { text: 'Supplier', value: 'supplierName' },
        { text: 'Sheet', value: 'sheet' },
        { text: 'From day', value: 'fromDay' },
        { text: 'Days', value: 'days' },
        { text: 'Group', value: 'grp' },
        { text: 'Pax', value: 'pax' },
        { text: 'Included', value: 'included' },
        { text: 'Sheet price', value: 'rentalPrice' },
        { text: 'Commission ratio', value: 'commissionRatio' },
        { text: 'Contribution Ratio', value: 'contributionRatio' },
        { text: 'Supplier Gross Price', value: 'supplierGrossPrice' },
        { text: 'Price', value: 'price' },
        { text: '', value: 'actions' },
      ],
    };
  },
  computed: {
    ...mapState({
      carRentals: state => state.itinerary.carRentals.items,
      loading: state => state.itinerary.carRentals.loading,
    }),
  },
  methods: {
    ...mapActions({
      deleteCarRentalPriceInterval: 'itinerary/deleteCarRentalPriceInterval',
      copyCarRentalPriceInterval: 'itinerary/copyCarRentalPriceInterval',
      updateCarRentalCommissionRatio: 'itinerary/updateCarRentalCommissionRatio',
      updateCarRentalContributionRatio: 'itinerary/updateCarRentalContributionRatio',
      calculateCarRental: 'itinerary/calculateCarRental',
    }),
    removeInterval(id) {
      this.deleteCarRentalPriceInterval({ id, priceIntervalId: this.selectedPriceInterval.id }).then(() => {
        this.$emit('sync');
      });
      this.$emit('delete');
    },
    copyInterval(id) {
      this.copyCarRentalPriceInterval({ id, priceIntervalId: this.selectedPriceInterval.id });
    },
    calculateCarRentalAndSync() {
      this.calculateCarRental().then(() => {
        this.$emit('sync');
      });
    },
    formatDate(date, format, placeholder) {
      const momentDate = this.$moment.utc(date);
      return momentDate.isValid()
        ? momentDate.local().format(format || 'DD-MM-YYYY HH:mm:ss')
        : (placeholder || '-');
    },
  },
};
</script>

<template>
  <div v-if="carRentals.length">
    <h2 class="mt-4">Selected car rentals</h2>
    <v-data-table
      :headers="headers"
      :items="carRentals"
      hide-actions
      disable-initial-sort
    >
      <template v-slot:items="props">
        <tr>
          <td class="text-xs-left">
            {{ props.item.supplierName }}
          </td>
          <td class="text-xs-left">
            {{ props.item.sheet }}
          </td>
          <td class="text-xs-left">
            {{ props.item.fromDay }}
          </td>
          <td class="text-xs-left">
            {{ props.item.days }}
          </td>
          <td class="text-xs-left">
            {{ props.item.grp }}
          </td>
          <td class="text-xs-left">
            {{ props.item.pax }}
          </td>
          <td class="text-xs-left">
            {{ props.item.included ? 'Included' : 'Optional' }}
          </td>
          <td class="text-xs-left">
            {{ props.item.rentalPrice }} {{ props.item.rentalCurrency }}
          </td>
          <td class="text-xs-left">
            <input
              :value="props.item.commissionRatio"
              type="number"
              step="0.01"
              class="table-input"
              @change="updateCarRentalCommissionRatio({ id: props.item.id, commissionRatio: $event.target.value })"
            />
            %
          </td>
          <td class="text-xs-left">
            <input
              :value="props.item.contributionRatio"
              type="number"
              step="0.01"
              class="table-input"
              @change="updateCarRentalContributionRatio({ id: props.item.id, contributionRatio: $event.target.value })"
            />
            %
          </td>
          <td class="text-xs-left">
            <input
              :value="props.item.supplierGrossPrice"
              type="number"
              step="0.01"
              disabled
              class="table-input"
            />
            {{ props.item.rentalCurrency }}
          </td>
          <td class="text-xs-left">
            <input
              :value="props.item.price"
              type="number"
              step="0.01"
              disabled
              class="table-input"
            />
            {{ props.item.rentalCurrency }}
          </td>
          <td class="text-xs-right">
            <v-btn
              color="primary"
              fab
              small
              @click="copyInterval(props.item.id)"
            >
              <v-icon>copy_all</v-icon>
            </v-btn>
            <v-btn
              color="error"
              fab
              small
              @click="removeInterval(props.item.id)"
            >
              <v-icon>delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
    <div class="actions">
      <v-btn
        :disabled="loading"
        color="primary"
        @click="calculateCarRentalAndSync()"
      >
        CALCULATE AND SYNC
      </v-btn>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .table-input {
    width: 80px !important;
  }

  .actions {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 32px;
  }
</style>



// WEBPACK FOOTER //
// src/components/itinerary/itineraryPrices/ItineraryPricesSelectedCarRentals.vue